import { render, staticRenderFns } from "./serviceAppointmentTemp.vue?vue&type=template&id=31c8af1f&scoped=true&"
import script from "./serviceAppointmentTemp.vue?vue&type=script&lang=js&"
export * from "./serviceAppointmentTemp.vue?vue&type=script&lang=js&"
import style0 from "./serviceAppointmentTemp.vue?vue&type=style&index=0&id=31c8af1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8af1f",
  null
  
)

export default component.exports